import React from 'react'
import { useSelector } from 'react-redux'
import { useCheckEditCampaignPermission, useCheckSomePermissions, usePermission } from 'hooks/permissions'
import { CAMPAIGN_STATUS_ENUM, selectEditingCampaignType } from 'state/campaigns'
import { selectIsInternalUser } from 'state/profile'
import { CampaignManagement, CampaignStatusControl } from './enums'

type RestrictedProps = {
    campaignStatus: CAMPAIGN_STATUS_ENUM | undefined
    isEditBrief?: boolean
    isEditDeadline?: boolean
    isAbleToReview?: boolean
    isAbleToLaunch?: boolean // use isAbleToLaunch to determine we should use which permission to control SaveAndSubmitButtonGroup display in wait for payment status
}

const EditCampaignRestricted: React.FC<RestrictedProps> = ({
    campaignStatus,
    isEditBrief = false,
    isEditDeadline = false,
    isAbleToReview = false,
    isAbleToLaunch = false,
    children,
}) => {
    const isInternalUser = useSelector(selectIsInternalUser)
    const isSelfServe = useSelector(selectEditingCampaignType)
    const canPublishOrEditLive =
        useCheckSomePermissions([
            CampaignStatusControl.LaunchCampaign,
            CampaignManagement.LiveCampaignEditBriefs,
            CampaignManagement.LiveCampaignEditDeadlines,
        ]) && campaignStatus === CAMPAIGN_STATUS_ENUM.LIVE
    const canPublishAndEditReview =
        usePermission(CampaignStatusControl.LaunchCampaign) &&
        (campaignStatus === CAMPAIGN_STATUS_ENUM.FOR_REVIEW ||
            campaignStatus === CAMPAIGN_STATUS_ENUM.WAIT_FOR_PAYMENT || // needs to show SaveSubmitButton group if campaign in wait for payment or ready for launch state
            campaignStatus === CAMPAIGN_STATUS_ENUM.READY_FOR_LAUNCH)
    const canEditDraft =
        usePermission(CampaignManagement.CreateAndEditBriefsForInternal) &&
        campaignStatus !== undefined &&
        [CAMPAIGN_STATUS_ENUM.DRAFT, CAMPAIGN_STATUS_ENUM.FOR_EDIT].includes(campaignStatus)
    const isPermissionEditable = useCheckEditCampaignPermission(
        campaignStatus,
        isEditBrief,
        isEditDeadline,
        isAbleToLaunch,
    )
    const isCampaignEditable = isInternalUser
        ? canEditDraft || canPublishAndEditReview || canPublishOrEditLive
        : isSelfServe

    const isShow =
        campaignStatus === undefined
            ? isPermissionEditable
            : (isCampaignEditable && isPermissionEditable) || isAbleToReview

    if (isShow) {
        return <>{children}</>
    }

    return null
}

export default EditCampaignRestricted
